import { EndPoints, get, post } from '../';
export function getConfig() {
    return get(EndPoints.config, {});
}
export function update(request) {
    return post(EndPoints.configUpdate, request);
}
